var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "collapsible",
      class: { "collapsible--active": _vm.isActive },
    },
    [
      _c(
        "div",
        {
          staticClass: "collapsible__title",
          class: { "flex items-center justify-between": !_vm.isDisabled },
          on: {
            click: function ($event) {
              return _vm.toggle()
            },
          },
        },
        [
          _c("div", [_vm._t("title")], 2),
          _vm._v(" "),
          !_vm.isDisabled
            ? _c("div", {
                staticClass: "collapsible__toggle",
                class: {
                  "collapsible__toggle--active": _vm.isActive,
                  "md:hidden": _vm.isDesktopDisabled,
                },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActive,
                expression: "isActive",
              },
            ],
            class: { "md:block": _vm.isDesktopDisabled },
          },
          [
            _c(
              "div",
              { staticClass: "collapsible__content" },
              [_vm._t("default")],
              2
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }